import {gql} from '@apollo/client';

export const BATCH_MARK_FOR_MANUAL_REVIEW = gql`
    mutation BatchMarkForManualReview($orderIds: [Long!]!) {
        batchMarkForManualReview(orderIds: $orderIds) {
            success
            markedCount
            failedCount
            failedTrackingNumbers
        }
    }
`;

export interface BatchMarkForManualReviewResponse {
    batchMarkForManualReview: {
        success: boolean;
        markedCount: number;
        failedCount: number;
        failedTrackingNumbers: string[];
    };
}

export interface BatchMarkForManualReviewVariables {
    orderIds: number[];
}
